import { BoundaryMap, WeeklySchedulePicker } from '@/components/controls';
import { Close as CloseIcon } from '@mui/icons-material';
import {
  Box,
  Chip,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import { deepOrange } from '@mui/material/colors';
import { format } from 'date-fns';
import { NavLink } from 'react-router';
import { ApplicableTo } from './ApplicableTo';
import { Attributes } from './Attributes';

export function Objective({ feature, onClose }) {
  const requirement = `Requires ${feature.properties.requiredVisits ?? 0} visits of ${
    feature.properties.complianceSeconds ?? 0 / 60
  } minutes ${feature.properties.requiredFrequency ?? ''}`;

  return (
    <Stack spacing={1} sx={{ p: 1, height: 1, width: 1 }}>
      <Stack
        direction="row"
        spacing={1}
        sx={{ alignItems: 'center', height: 24 }}
      >
        <Typography variant="h6">{feature.properties.title}</Typography>
        <Typography variant="subtitle2" color="textSecondary">
          {`${format(feature.properties.startTime, 'dd/MM/yyyy')} - ${format(
            feature.properties.endTime,
            'dd/MM/yyyy',
          )}`}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        {feature.properties.occurrenceNumber && (
          <Chip
            size="small"
            label={feature.properties.occurrenceNumber}
            sx={{
              bgcolor: deepOrange[500],
              color: '#fff',
            }}
          />
        )}
        <Chip
          size="small"
          label={`#${feature.properties.identifier}`}
          component={NavLink}
          to={`/objectives/${feature.properties.identifier}`}
          sx={{ cursor: 'pointer' }}
        />
        <Box>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Box>
      </Stack>
      <Stack spacing={2} direction="row">
        <BoundaryMap
          sx={{ position: 'relative', width: 320, height: 320 }}
          boundary={feature.geometry}
        />
        <Stack
          spacing={1}
          sx={{ flex: 1, height: 320, overflow: 'auto', pb: 1, pr: 1 }}
        >
          <Typography variant="body2">{requirement}</Typography>
          <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap' }}>
            {(feature.properties.microbeats ?? []).map((microbeat) => (
              <Chip
                size="small"
                key={microbeat}
                label={microbeat}
                sx={{ fontSize: '.6rem', height: 18 }}
              />
            ))}
          </Stack>
          <WeeklySchedulePicker
            value={feature.properties.schedule}
            disabled
            scale={0.5}
          />
          <Divider>
            <Typography variant="caption" color="textSecondary">
              Applicable To
            </Typography>
          </Divider>
          <ApplicableTo properties={feature.properties} />
          <Divider>
            <Typography variant="caption" color="textSecondary">
              Attributes
            </Typography>
          </Divider>
          <Attributes properties={feature.properties} />
        </Stack>
      </Stack>
      <Divider />
      <Box
        sx={{
          overflow: 'auto',
          p: 1,
          '& img': { maxWidth: ['100%', '!important'] },
        }}
        dangerouslySetInnerHTML={{ __html: feature.properties.contentHTML }}
      />
    </Stack>
  );
}
